import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CurrencyDollarIcon } from '@heroicons/react/20/solid';
import { ErrorBoundary } from '../helper/error-boundary';
import { ResultWrapper } from '../helper/result-wrapper';
export const ZoneResult = ({ zone, onSelect, }) => {
    const { zoneName } = zone;
    const handleRedirect = () => {
        onSelect(zone, zone.id, 'pricing');
    };
    return (_jsx(ErrorBoundary, { children: _jsxs(ResultWrapper, { onRedirect: handleRedirect, children: [_jsx(CurrencyDollarIcon, { className: "size-4" }), _jsx("div", { className: "border-l-2 border-gray-300 pl-2", children: zoneName })] }) }));
};
//# sourceMappingURL=zone-results.js.map